import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing, BellOff, Smartphone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { enablePush, disablePush, getPushSubscription, pushSupported } from "@/lib/push";

export default function PushCard() {
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const supported = pushSupported();

  useEffect(() => { getPushSubscription().then((s) => setEnabled(!!s)).catch(() => {}); }, []);

  const toggle = async () => {
    setBusy(true);
    try {
      if (enabled) { await disablePush(); setEnabled(false); toast.success("Notifiche sul telefono disattivate"); }
      else { await enablePush(); setEnabled(true); toast.success("Notifiche attivate! Ti arriva un messaggio di prova."); api.post("/push/test").catch(() => {}); }
    } catch (e) { toast.error(e.message || "Impossibile attivare le notifiche"); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="push-card" className="border border-neutral-200 rounded-2xl p-4">
      <div className="flex items-center gap-2 mb-1"><Smartphone size={18} /><h2 className="font-display font-bold">Notifiche sul telefono</h2></div>
      <p className="text-xs text-neutral-500 mb-3">Ricevi agganci, vendite, messaggi e pagamenti come notifiche push su telefono e computer, anche con l'app chiusa.</p>
      <p data-testid="push-status" className={`text-sm mb-3 ${enabled ? "text-green-700" : "text-neutral-600"}`}>{!supported ? "Questo browser non supporta le notifiche push." : enabled ? "Notifiche attive su questo dispositivo" : "Notifiche non attive su questo dispositivo"}</p>
      {supported && (
        <Button data-testid="push-toggle-btn" onClick={toggle} disabled={busy} variant={enabled ? "outline" : "default"} className={`w-full h-11 rounded-full ${enabled ? "" : "bg-black text-white hover:bg-neutral-800"}`}>
          {enabled ? <BellOff size={16} className="mr-1" /> : <BellRing size={16} className="mr-1" />}{busy ? "…" : enabled ? "Disattiva notifiche" : "Attiva notifiche sul telefono"}
        </Button>
      )}
    </div>
  );
}
